import { Button, Typography } from "@material-ui/core";

import MeditocPopover from "../../../utils/MeditocPopover";
import { useCallCenter } from "../../../../context/CallCenterContext";

export default function HelperInicio() {
    const {
        popoverInicio,
        handleChangePopoverInicio,
        handleClickCloseInicio,
        handleClickCloseDisponible,
    } = useCallCenter();

    return (
        <MeditocPopover open={popoverInicio} setopen={handleChangePopoverInicio}>
            <Typography variant="body2" paragraph>
                TU ESTATUS ACTUAL ES OCUPADO.
            </Typography>
            <Typography variant="body2" paragraph>
                Cambia tu estatus a DISPONIBLE para comenzar a
                <br />
                recibir videollamadas y chats de tus pacientes
            </Typography>
            <Button color="default" style={{ color: "#888" }} onClick={handleClickCloseInicio}>
                <Typography variant="body2">CONTINUAR OCUPADO</Typography>
            </Button>
            <Button color="primary" onClick={handleClickCloseDisponible}>
                <Typography variant="body2">CAMBIAR A DISPONIBLE</Typography>
            </Button>
        </MeditocPopover>
    );
}
